import { render } from "./ButtonCustom.vue?vue&type=template&id=91b37018&ts=true"
import script from "./ButtonCustom.vue?vue&type=script&lang=ts"
export * from "./ButtonCustom.vue?vue&type=script&lang=ts"

import "./ButtonCustom.vue?vue&type=style&index=0&id=91b37018&lang=scss"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__